module.exports = __webpack_public_path__ + "img/parque-dom-pedro.69593a00.png";